import { useMemo } from 'react';

import { ClientPod } from '../generated/graphql';
import { useAppSelector } from '../store/store';

import { getContactEmailByPod } from './getContactEmailByPod';
import { getUserPod } from './getUserPod';

interface UseContactEmailReturn {
  contactEmail: string;
  userPod: ClientPod;
  isLoading: boolean;
}

/**
 * Custom hook to get the appropriate company contact email based on user's client pod
 * @returns The contact email, user pod, and loading state
 */
export const useContactEmail = (): UseContactEmailReturn => {
  const user = useAppSelector((state) => state.user);

  return useMemo(() => {
    const isLoading = !user.id; // User data not loaded yet
    const userPod = getUserPod(user);
    const contactEmail = getContactEmailByPod(userPod);

    return {
      contactEmail,
      userPod,
      isLoading,
    };
  }, [user]);
};
